import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["toggle", "price", "billing", "monthlyAction", "yearlyAction", "savings"]

    connect() {
        this.updatePrices()
    }

    toggle() {
        this.updatePrices()
    }

    updatePrices() {
        const isAnnual = this.toggleTarget.checked

        this.priceTargets.forEach(target => {
            const monthlyPrice = target.dataset.pricingMonthlyPrice
            const annualPrice = target.dataset.pricingAnnualPrice

            // Animate price change
            target.style.transition = 'opacity 0.15s ease-out'
            target.style.opacity = '0'
            setTimeout(() => {
                target.innerText = isAnnual ? annualPrice : monthlyPrice
                target.style.opacity = '1'
            }, 150)
        })

        this.billingTargets.forEach(target => {
            const annualText = target.dataset.pricingAnnualText
            const monthlyText = target.dataset.pricingMonthlyText

            target.style.transition = 'opacity 0.15s ease-out'
            target.style.opacity = '0'
            setTimeout(() => {
                target.innerText = isAnnual ? annualText : monthlyText
                target.style.opacity = '1'
            }, 150)
        })

        if (this.hasMonthlyActionTarget) {
            this.monthlyActionTargets.forEach(target => {
                if (isAnnual) {
                    target.classList.add('hidden')
                } else {
                    target.classList.remove('hidden')
                }
            })
        }

        if (this.hasYearlyActionTarget) {
            this.yearlyActionTargets.forEach(target => {
                if (isAnnual) {
                    target.classList.remove('hidden')
                } else {
                    target.classList.add('hidden')
                }
            })
        }

        if (this.hasSavingsTarget) {
            this.savingsTargets.forEach(target => {
                if (isAnnual) {
                    target.classList.remove('hidden')
                } else {
                    target.classList.add('hidden')
                }
            })
        }
    }
}
